import ConsultasShared from "../profesor/ConsultasColegio";
export default function PadreConsultas() {
    return <ConsultasShared />;
}
